import { useEditorModel } from '@/store/models/editor-model';

export const LOCK_APP_CLASS_NAME = 'c-lock-app';

/**
 * 图片编辑器未初始化，用来锁定面板功能
 */
export const useLockAppData = () => {
    const isLock = useEditorModel((state) => state.isLock);
    return {
        'c-lock-app': isLock,
        isLock,
    };
};

/**
 * 禁用编辑器各个面板
 */
export const useDisableAppData = () => {
    const isDisable = useEditorModel((state) => state.isDisable);
    return {
        ['c-disable-app']: isDisable,
        isDisable,
    };
};
